import { UtilType } from '@/components/common/Input';
import TextForm from '@/components/Form/TextForm';
import REGISTER_NAME from '@/pages/root/constants/registerName';

type Props = {
  updateCompanyName: () => void;
};

const MyBizInput = ({ updateCompanyName }: Props) => {
  return (
    <div className="mybiz_sch">
      <TextForm
        width={350}
        utilType={UtilType.Search}
        placeholder="사업자명을 입력해 주세요"
        label="MY BIZ"
        onClickUtil={updateCompanyName}
        registerName={REGISTER_NAME.MY_BIZ}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            updateCompanyName();
          }
        }}
      />
    </div>
  );
};

export default MyBizInput;
